import Layout from '../../components/Layout';

const GettingStartedGuide = () => {
    return (
        <Layout>
            <iframe
                title="navod"
                // src="https://arbitrage.sk/getting-started-guide"
                // src="https://arbitrage.sk/#blog"
                src="/navodsoft.html"

                style={{
                    width: "100%",
                    height: "100vh",
                    border: "none",
                }}
            />
        </Layout>
    );
};

export default GettingStartedGuide;
